import React from 'react';
import { IoCheckmarkCircle, IoCloseCircle } from 'react-icons/io5';

export type FireEgressBadgeStatus =
  | null
  | { compliant: true; pass: 'sliding' | 'tilting' | 'both' }
  | { compliant: false };

const PASS_LABEL: Record<'sliding' | 'tilting' | 'both', string> = {
  sliding: 'Sliding',
  tilting: 'Tilting',
  both: 'Sliding/Tilting',
};

interface FireEgressBadgeProps {
  status: FireEgressBadgeStatus;
  className?: string;
}

/**
 * Mobile-app-style compliance pill for window configuration items —
 * green "Compliant" / red "Non-Compliant", matching the mobile app's
 * Fire Egress badge (bg-{color}-50, border, rounded-full, checkmark icon).
 */
export const FireEgressBadge: React.FC<FireEgressBadgeProps> = ({ status, className = '' }) => {
  if (!status) return null;

  const compliant = status.compliant;
  const label = compliant
    ? `Fire Egress: Compliant${status.pass ? ` (${PASS_LABEL[status.pass]})` : ''}`
    : 'Fire Egress: Non-Compliant';

  return (
    <div
      className={`mb-3 flex w-full items-center gap-1.5 rounded-md border px-3 py-1.5 ${
        compliant
          ? 'border-green-300 bg-green-50'
          : 'border-red-300 bg-red-50'
      } ${className}`}
    >
      {compliant ? (
        <IoCheckmarkCircle size={16} color="#15803d" />
      ) : (
        <IoCloseCircle size={16} color="#b91c1c" />
      )}
      <span className={`text-sm font-semibold ${compliant ? 'text-green-700' : 'text-red-700'}`}>
        {label}
      </span>
    </div>
  );
};
